// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmAlert_container__3CtBX","title":"ConfirmAlert_title__2PDmy","confirmBtn":"ConfirmAlert_confirmBtn__33oHJ","codeInput":"ConfirmAlert_codeInput__G9CUH"};